module.exports = __webpack_public_path__ + "static/media/ic_printer.1c504a4e.png";